import React, { useState, useEffect } from "react";
import { useAuthContext } from "../../../hooks/useAuthContext";
import "react-tabs/style/react-tabs.css";
import { utilUpdateDocument } from "../../../util/UtilsFirebase";
import {
  Table,
  Pagination,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Button,
  Col,
  Form,
} from "react-bootstrap";
import Switch from "react-switch";
import "./Puestos.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import {
  collection,
  doc,
  getDoc,
  onSnapshot,
  query,
  Timestamp,
  updateDoc,
  where,
} from "firebase/firestore";
import { projectFirestore } from "../../../firebase/config";
import moment from "moment/moment";

export default function Puestos() {
  const { register } = useAuthContext();
  const [data, setData] = useState([]);
  const [dataP, setDataP] = useState([]);
  const [document, setDocument] = useState(null);
  const [papelera, setPapelera] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [idRegistro, setIdRegistro] = useState(null);
  const [valueStatus, setValueStatus] = useState(false);
  const [userRegistro, setUserRegistro] = useState(false);
  const [modalRegistro, setModalRegistro] = useState(false);
  const [currentPagePapelera, setCurrentPagePapelera] = useState(1);
  const [codigoPuesto, setCodigoPuesto] = useState("");
  const customModalStyles = {
    content: {
      width: "600px",
      height: "200px",
      margin: "auto",
      border: "none",
      textAlign: "center",
      borderRadius: "8px",
      boxShadow: "0 2px 10px rgba(0, 0, 0, 0.15)",
    },
  };

  /* Paginado Tablas */
  const [currentPage, setCurrentPage] = useState(1);
  const elementsPerPage = 7;
  const elementsPerPagePap = 3;

  const getElementsForPage = (page) => {
    const startIndex = (page - 1) * elementsPerPage;
    const endIndex = startIndex + elementsPerPage;
    return data.slice(startIndex, endIndex);
  };

  const getElementsForPagePap = (page) => {
    const startIndex = (page - 1) * elementsPerPagePap;
    const endIndex = startIndex + elementsPerPagePap;
    return dataP.slice(startIndex, endIndex);
  };

  useEffect(() => {
    async function getMenu() {
      let document = doc(projectFirestore, "registro", register.id);
      setDocument(document);
      const filtros = [{ campo: "admin", operador: "==", valor: document }];
      let q = query(collection(projectFirestore, "registro"));
      filtros.forEach((filtro) => {
        const { campo, operador, valor } = filtro;
        q = query(q, where(campo, operador, valor));
      });
      onSnapshot(q, async (docs) => {
        const documentosColeccion = [];
        const documentosPapelera = [];
        await docs.docs.forEach(async (docss) => {
          const data = docss.data();
          data.id = docss.id;
          var qrText = "https://quickchart.io/qr?text=T-" + data.id;
          data.qr = qrText;
          if (!data.papelera || data.papelera === false) {
            documentosColeccion.push(data);
          } else {
            documentosPapelera.push(data);
          }
        });
        setData(documentosColeccion);
        setDataP(documentosPapelera);
      });
    }
    getMenu();
  }, [register.id]);

  const handleAñadirPuesto = () => {
    setCodigoPuesto("");
    setModalRegistro(true);
  };

  const handleCloseRegistro = () => {
    setModalRegistro(false);
  };

  const handleEliminarPuesto = async (id) => {
    const docd = await getDoc(doc(projectFirestore, "registro", id));
    updateDoc(docd.ref, { papelera: true, fecha_papelera: Timestamp.now() });
  };

  const handleRecuperarPuesto = async (id) => {
    const docd = await getDoc(doc(projectFirestore, "registro", id));
    updateDoc(docd.ref, { papelera: false });
  };

  const openConfirmModal = async (id, userParam, newValue) => {
    setIdRegistro(id);
    setValueStatus(newValue);
    console.log(userParam);
    setUserRegistro(userParam);
    setIsModalOpen(true);
  };

  const handleConfirmModalRegistro = async () => {
    try {
      if (codigoPuesto === "") {
        alert("Ingrese un codigo");
        return;
      }
      let respuesta = await utilUpdateDocument("registro", codigoPuesto, {
        admin: document,
      });
      if (respuesta) {
        alert("Se añadio el puesto correctamente");
        return;
      } else {
        alert(
          "Hubo un error al añadir el puesto\n asegurese de ingresar correctamente el codigo."
        );
        return;
      }
    } catch (error) {
      alert("Hubo un error al añadir el puesto.");
      console.error("Error updating document: ", error);
    }
  };

  const handleCheckboxChange = async (id, userRegistro, newValue) => {
    try {
      // Actualiza el campo 'activo' en Firebase para el documento con el ID dado
      console.log(newValue);
      await utilUpdateDocument("registro", id, { valid: newValue });
      //await updateActiveDisabledAccount(userRegistro,newValue);
      // Actualiza el estado 'data' para reflejar el cambio localmente
      setData((prevData) =>
        prevData.map((item) =>
          item.id === id ? { ...item, estatus: newValue } : item
        )
      );
    } catch (error) {
      console.error("Error updating document: ", error);
    }
  };

  const handleConfirmModal = async () => {
    await handleCheckboxChange(idRegistro, userRegistro, valueStatus);
    setIsModalOpen(false);
  };

  const handleCancelModal = () => {
    // El usuario canceló el envío del formulario
    console.log("Envío del formulario cancelado");
    setIsModalOpen(false);
  };

  return (
    <div className="row">
      <br />
      <h4 className="page-title">Puestos</h4>
      <br />
      <br />
      <div className="container">
        <>
          <div className="mrg-titulo mrg-tbl">
            <button
              style={{ marginLeft: "20px" }}
              onClick={() => handleAñadirPuesto()}
              className="btn btn-primary btn-xs"
            >
              <FontAwesomeIcon icon={faPlus} /> Añadir puesto
            </button>
            <button
              style={{ marginLeft: "20px" }}
              onClick={() => {
                setPapelera(true);
              }}
              className="btn btn-danger btn-xs"
            >
              <FontAwesomeIcon icon={faTrash} /> Papelera
            </button>
          </div>
          <div className="row">
            <div className="col-lg-12 mrg-tbl">
              <Table striped bordered hover border="2">
                <thead>
                  <tr>
                    <th>QR</th>
                    <th>Imagen</th>
                    <th>Nombre</th>
                    <th>Propietario</th>
                    <th>E-mail</th>
                    <th>Estatus</th>
                    <th>Eliminar</th>
                  </tr>
                </thead>
                <tbody>
                  {getElementsForPage(currentPage)
                    .sort()
                    .map((val, key) => {
                      return (
                        <tr key={key}>
                          <td>
                            <img
                              className="qr-code-puestos"
                              src={val.qr}
                              alt=""
                            ></img>
                          </td>
                          <td>
                            <img
                              className="qr-code-puestos"
                              style={{ marginRight: 20 }}
                              src={val.img}
                              alt=""
                            ></img>
                          </td>
                          <td>{val.name}</td>
                          <td>{val.full_name}</td>
                          <td>{val.email}</td>
                          <td>
                            <Switch
                              onChange={(e) =>
                                openConfirmModal(val.id, val.user.id, e)
                              }
                              checked={val.valid}
                            />
                          </td>
                          <td>
                            <button
                              style={{ marginLeft: "10px" }}
                              onClick={() => handleEliminarPuesto(val.id)}
                              className="btn btn-danger"
                            >
                              <FontAwesomeIcon icon={faTrash} />
                            </button>
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </Table>
              <Pagination>
                {Array.from({
                  length: Math.ceil(data.length / elementsPerPage),
                }).map((page, index) => (
                  <Pagination.Item
                    key={index}
                    active={index + 1 === currentPage}
                    className={index + 1 === currentPage ? "btn-paginado" : ""}
                    onClick={() => setCurrentPage(index + 1)}
                  >
                    {index + 1}
                  </Pagination.Item>
                ))}
              </Pagination>
            </div>
          </div>
        </>
      </div>
      <Modal
        style={customModalStyles}
        show={isModalOpen}
        onExit={() => setIsModalOpen(false)}
        contentLabel="Confirmación"
      >
        <ModalHeader>¿Desea actualizar la informacion?</ModalHeader>
        <ModalFooter>
          <Button
            style={{ marginRight: 5 }}
            variant="primary"
            onClick={handleConfirmModal}
          >
            Aceptar
          </Button>
          <Button variant="primary" onClick={handleCancelModal}>
            Cancelar
          </Button>
        </ModalFooter>
      </Modal>
      <Modal
        show={papelera}
        size="lg"
        onExit={() => {
          setPapelera(false);
        }}
      >
        <ModalHeader>Puestos eliminados</ModalHeader>
        <ModalBody>
          <div>
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>Imagen</th>
                  <th>Nombre</th>
                  <th>Propietario</th>
                  <th>Eliminado</th>
                  <th>Recuperar</th>
                </tr>
              </thead>
              <tbody>
                {getElementsForPagePap(currentPagePapelera)
                  .sort()
                  .map((val, key) => {
                    return (
                      <tr key={key}>
                        <td>
                          <img
                            className="qr-code-puestos"
                            style={{ marginRight: 20 }}
                            src={val.img}
                            alt=""
                          ></img>
                        </td>
                        <td>{val.name}</td>
                        <td>{val.full_name}</td>
                        <td>
                          {val.fecha_papelera
                            ? moment(Timestamp.now().seconds * 1000).diff(
                                new moment(val.fecha_papelera.seconds * 1000),
                                "days"
                              ) + " Dias"
                            : ""}
                        </td>
                        <td>
                          <button
                            style={{ marginLeft: "10px" }}
                            onClick={() => handleRecuperarPuesto(val.id)}
                            className="btn btn-success"
                          >
                            <FontAwesomeIcon icon={faCheck} />
                          </button>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </Table>
            <Pagination>
              {Array.from({
                length: Math.ceil(dataP.length / elementsPerPagePap),
              }).map((page, index) => (
                <Pagination.Item
                  key={index}
                  active={index + 1 === currentPage}
                  className={index + 1 === currentPage ? "btn-paginado" : ""}
                  onClick={() => setCurrentPagePapelera(index + 1)}
                >
                  {index + 1}
                </Pagination.Item>
              ))}
            </Pagination>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button
            variant="secondary"
            onClick={() => {
              setPapelera(false);
            }}
          >
            Cerrar
          </Button>
        </ModalFooter>
      </Modal>
      <Modal
        style={customModalStyles}
        show={modalRegistro}
        onExit={() => setModalRegistro(false)}
        contentLabel="Confirmación"
      >
        <ModalHeader>Añadir puesto</ModalHeader>
        <ModalBody>
          <Col md={12}>
            <Form.Group controlId="razonSocial">
              <Form.Label>Codigo del puesto:</Form.Label>
              <Form.Control
                onChange={(e) => setCodigoPuesto(e.target.value)}
                value={codigoPuesto}
                name="codigopuesto"
                id="codigopuesto"
                required
                type="text"
              />
            </Form.Group>
          </Col>
        </ModalBody>
        <ModalFooter>
          <Button
            style={{ marginRight: 5 }}
            variant="primary"
            onClick={handleConfirmModalRegistro}
          >
            Aceptar
          </Button>
          <Button variant="primary" onClick={handleCloseRegistro}>
            Cancelar
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}
